/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Refresh_FailedInputs */

const vi_einvoice_refresh_failed = /** @type {(inputs: Einvoice_Refresh_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể làm mới trạng thái hóa đơn từ MISA`)
};

/**

* @param {Einvoice_Refresh_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_refresh_failed = /** @type {((inputs?: Einvoice_Refresh_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Refresh_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_refresh_failed(inputs)
});